import { EXTENSAO_ARQUIVO_EXCEL } from './Constantes';

export const converterArquivoStreamParaBlob = (arquivoStream) => {
  return new Blob([arquivoStream], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8" });
};

export const formatarNomeArquivo = (nomeArquivo, extensao) => {
  return `${nomeArquivo}.${extensao}`;
};

export const iniciarDownload = (arquivo, nome) => {
  const nomeArquivo = formatarNomeArquivo(nome, EXTENSAO_ARQUIVO_EXCEL);

  if (arquivo && arquivo.size > 0) {
    if (window.navigator && (window.navigator).msSaveOrOpenBlob) {
      (window.navigator).msSaveOrOpenBlob(arquivo, nomeArquivo);
    } else {
      const linkDownload = document.createElement('a');
      linkDownload.href = URL.createObjectURL(arquivo);
      linkDownload.download = nomeArquivo ?? '';
      linkDownload.click();
    }
  }
};
